import { useEffect } from 'react';

export const DynamicStyleLoader = (props: {cssUrl: string}) => {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = props.cssUrl;
    link.type = 'text/css';
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [props.cssUrl]);

  return null;
}
